import { AppLayout } from "@bcc/components/app-layout";
import { NotificationsView } from "@bcc/components/views/notifications-view";

interface NotificationData {
  id: number;
  type: "order" | "alert" | "success";
  title: string;
  message: string;
  time: string;
  icon: string;
  unread: boolean;
}

const notificationsData: NotificationData[] = [
  {
    id: 1,
    type: "order",
    title: "New Order Received",
    message:
      "Cafe Milano has placed an order for 100 bags of Ethiopia Yirgacheffe",
    time: "2 hours ago",
    icon: "Package",
    unread: true,
  },
  {
    id: 2,
    type: "alert",
    title: "Low Stock Alert",
    message: "Colombia Supremo inventory is below minimum threshold",
    time: "5 hours ago",
    icon: "AlertTriangle",
    unread: true,
  },
  {
    id: 3,
    type: "success",
    title: "Shipment Delivered",
    message: "Your shipment to Bean Street was delivered successfully",
    time: "1 day ago",
    icon: "CheckCircle",
    unread: false,
  },
  {
    id: 4,
    type: "order",
    title: "Order Confirmation",
    message: "Coffee Corner has confirmed their pending order",
    time: "2 days ago",
    icon: "Package",
    unread: false,
  },
  {
    id: 5,
    type: "success",
    title: "Payment Processed",
    message: "Payment of $2,500 from Artisan Cafe has been processed",
    time: "3 days ago",
    icon: "CheckCircle",
    unread: false,
  },
];

export function NotificationsPage() {
  return (
    <AppLayout>
      <NotificationsView notificationsData={notificationsData} />
    </AppLayout>
  );
}
